var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M5 6l3.472 3.472L11.944 6"}));
}

Down.defaultProps = {"width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"};

module.exports = Down;

Down.default = Down;
